/**
 * Paycheck Deductions Manager
 * Centralizes the logic for managing paycheck deductions across the site
 * Priority: Customer Tags > Landing Page > Default (4)
 */

window.PaycheckDeductions = (function() {
  'use strict';
  
  // Configuration mapping for all landing pages and their deduction counts
  const LANDING_PAGE_CONFIG = {
    'uhs': { 
      deductions: 2, 
      name: 'University Health San Antonio',
      account: 'UHS',
      paths: ['/pages/uhs']
    },
    'mgm': { 
    deductions: 4, 
    name: 'MGM',
    account: 'MGM',
    paths: ['/pages/mgm']
    },
    'umich': { 
    deductions: 3, 
    name: 'University of Michigan Health System',
    account: 'UMich',
    paths: ['/pages/umich']
    },
    'mckinney': { 
      deductions: 2, 
      name: 'McKinney',
      account: 'Mckinney',
      paths: ['/pages/mckinney']
    },
    'mercyS': { 
      deductions: 2, 
      name: 'Mercy Springfield',
      account: 'Mercy',
      paths: ['/pages/mercys']
    },
    'cfvh': { 
      deductions: 3, 
      name: 'Cape Fear Valley Hospital',
      account: 'CFVH',
      paths: ['/pages/cfvh']
    },
    'chattanooga': { 
      deductions: 3, 
      name: 'Chattanooga',
      account: 'Chattanooga',
      paths: ['/pages/chattanooga']
    },
    'chisj': { 
      deductions: 4, 
      name: 'CHI St. Joseph Health',
      account: 'CHISJ',
      paths: ['/pages/chisj']
    },
    'colquitt': { 
      deductions: 4, 
      name: 'Colquitt Regional Medical Center',
      account: 'Colquitt',
      paths: ['/pages/colquitt']
    },
    'fslv': { 
      deductions: 4, 
      name: 'Four Seasons Las Vegas',
      account: 'FSLV',
      paths: ['/pages/fslv']
    },
    'hendrick': { 
      deductions: 3, 
      name: 'Hendrick Health',
      account: 'Hendrick',
      paths: ['/pages/hendrick']
    },
    'wsk': { 
      deductions: 4, 
      name: 'WSK',
      account: 'WSK',
      paths: ['/pages/wsk']
    },
    'sghs': { 
      deductions: 4, 
      name: 'SGHS',
      account: 'Southeast Georgia',
      paths: ['/pages/sghs']
    },
    'wss': { 
      deductions: 4, 
      name: 'WSS',
      account: 'WSS',
      paths: ['/pages/wss']
    },
    'wsg': { 
      deductions: 4, 
      name: 'WSG',
      account: 'WSG',
      paths: ['/pages/wsg']
    },
    'wl': { 
      deductions: 4, 
      name: 'WL',
      account: 'WL',
      paths: ['/pages/wl']
    },
    'cno': { 
      deductions: 5, 
      name: 'CNO',
      account: 'CNO',
      paths: ['/pages/cno']
    },
    'cherokee': { 
      deductions: 5, 
      name: 'Harrahs Cherokee Casino',
      account: 'Cherokee',
      paths: ['/pages/cherokee']
    },
    'hfh': { 
      deductions: 5, 
      name: 'HFH',
      account: 'HFH',
      paths: ['/pages/hfh']
    },
    'forsyth': { 
      deductions: 5, 
      name: 'Forsyth',
      account: 'Forsyth',
      paths: ['/pages/forsyth']
    },
    'mt': { 
      deductions: 5, 
      name: 'MT',
      account: 'MT',
      paths: ['/pages/mt']
    },
    'christus': { 
      deductions: 6, 
      name: 'Christus',
      account: 'Christus',
      paths: ['/pages/christus']
    },
    'fitz': { 
      deductions: 6, 
      name: 'FITZ',
      account: 'FITZ',
      paths: ['/pages/fitz']
    },
    'gnlc': { 
      deductions: 6, 
      name: 'GNLC',
      account: 'GNLC',
      paths: ['/pages/gnlc']
    },
    'hss': { 
      deductions: 6, 
      name: 'HSS',
      account: 'HSS',
      paths: ['/pages/hss']
    },
    'huh': { 
      deductions: 6, 
      name: 'HUH',
      account: 'HUH',
      paths: ['/pages/huh']
    },
    'midland': { 
      deductions: 6, 
      name: 'Midland',
      account: 'Midland',
      paths: ['/pages/midland']
    },
    'uab': { 
      deductions: 4, 
      name: 'UAB',
      account: 'UAB',
      paths: ['/pages/uab']
    },
    'grmc': { 
      deductions: 6, 
      name: 'GRMC',
      account: 'GRMC',
      paths: ['/pages/grmc']
    }
  };
  
  const DEFAULT_DEDUCTIONS = 4;
  
  /**
   * Sets landing page information in storage
   * @param {string} pageKey - The key for the landing page configuration
   * @param {boolean} persist - Whether to persist in localStorage as well
   */
  function setLandingPage(pageKey, persist = true) {
    const config = LANDING_PAGE_CONFIG[pageKey.toLowerCase()];
    
    if (!config) {
      console.warn(`Unknown landing page key: ${pageKey}`);
      return false;
    }
    
    const landingPageInfo = {
      path: config.paths[0],
      account: config.account,
      name: config.name,
      deductions: config.deductions,
      timestamp: Date.now(),
      domain: window.location.hostname
    };
    
    // Always set in sessionStorage (primary storage)
    sessionStorage.setItem('landing_page_info', JSON.stringify(landingPageInfo));
    sessionStorage.setItem('paymentDeductions', String(config.deductions));
    sessionStorage.setItem('landingPage', pageKey);
    
    // Optionally persist in localStorage for cross-session tracking
    if (persist) {
      localStorage.setItem('landing_page_info', JSON.stringify(landingPageInfo));
      localStorage.setItem('paymentDeductions', String(config.deductions));
      localStorage.setItem('landingPage', pageKey);
    }
    
    console.log(`Landing page set: ${config.name} with ${config.deductions} deductions`);
    return true;
  }
  
  /**
   * Gets the current landing page information
   * @returns {Object|null} The landing page info or null if not set
   */
  function getLandingPageInfo() {
    // Check sessionStorage first (current session)
    let info = sessionStorage.getItem('landing_page_info');
    if (info) {
      try {
        return JSON.parse(info);
      } catch (e) {
        console.error('Error parsing landing_page_info from session:', e);
      }
    }
    
    // Fall back to localStorage (previous session)
    info = localStorage.getItem('landing_page_info');
    if (info) {
      try {
        const parsed = JSON.parse(info);
        // Copy to sessionStorage for this session
        sessionStorage.setItem('landing_page_info', info);
        sessionStorage.setItem('paymentDeductions', String(parsed.deductions));
        return parsed;
      } catch (e) {
        console.error('Error parsing landing_page_info from localStorage:', e);
      }
    }
    
    return null;
  }
  
  /**
   * Gets the current deduction count based on priority
   * @param {Array} customerTags - Array of customer tags (if logged in)
   * @returns {Object} Object with deduction count and source
   */
  function getDeductionCount(customerTags = []) {
    // Priority 1: Check customer tags
    if (customerTags && customerTags.length > 0) {
      for (const [key, config] of Object.entries(LANDING_PAGE_CONFIG)) {
        if (customerTags.includes(config.account)) {
          return {
            count: config.deductions,
            source: 'customer_tag',
            account: config.account
          };
        }
      }
    }
    
    // Priority 2: Check landing page
    const landingPageInfo = getLandingPageInfo();
    if (landingPageInfo && landingPageInfo.deductions) {
      return {
        count: landingPageInfo.deductions,
        source: 'landing_page',
        account: landingPageInfo.account
      };
    }
    
    // Priority 3: Default
    return {
      count: DEFAULT_DEDUCTIONS,
      source: 'default',
      account: null
    };
  }
  
  /**
   * Clears landing page information from storage
   */
  function clearLandingPage() {
    sessionStorage.removeItem('landing_page_info');
    sessionStorage.removeItem('paymentDeductions');
    sessionStorage.removeItem('landingPage');
    localStorage.removeItem('landing_page_info');
    localStorage.removeItem('paymentDeductions');
    localStorage.removeItem('landingPage');
    console.log('Landing page information cleared');
  }
  
  /**
   * Auto-detect landing page from current URL
   * @returns {boolean} True if landing page was detected and set
   */
  function autoDetectLandingPage() {
    const currentPath = window.location.pathname.toLowerCase();
    
    for (const [key, config] of Object.entries(LANDING_PAGE_CONFIG)) {
      if (config.paths.some(path => currentPath.includes(path))) {
        return setLandingPage(key);
      }
    }
    
    return false;
  }
  
  /**
   * Initialize the deduction manager
   * Auto-detects landing page if on one
   */
  function init() {
    // Only auto-detect if we're actually on a landing page
    // This prevents overwriting existing landing page info when navigating elsewhere
    if (window.location.pathname.includes('/pages/')) {
      autoDetectLandingPage();
    }
  }
  
  // Public API
  return {
    setLandingPage,
    getLandingPageInfo,
    getDeductionCount,
    clearLandingPage,
    autoDetectLandingPage,
    init,
    CONFIG: LANDING_PAGE_CONFIG,
    DEFAULT_DEDUCTIONS
  };
})();

// Auto-initialize when the script loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', PaycheckDeductions.init);
} else {
  PaycheckDeductions.init();
}